import React from 'react';
import SvgIcon48 from '../svgIcon48';

/* eslint-disable max-len */
/* eslint-disable react/self-closing-comp */

const HeartIcon = ({ ...others }) => (
  <SvgIcon48
    title="icons / nav / heart"
    {...others}
  >
    <g transform="translate(-11,4) scale(1.8,1.8)">
      <path d="M25.8652238,0.12907923 C23.4275939,0.106479753 21.1587336,1.37412917 19.8957918,3.46429866 C18.3336929,0.752113222 15.1506737,-0.57216073 12.1318533,0.234163688 C9.11303279,1.04048811 7.00932079,3.77684353 7.00053304,6.90861148 C6.90502213,15.8841889 19.6765759,24 19.6765759,24 C19.6765759,24 32.6179371,16.1592699 32.7136317,7.18378458 C32.7657213,3.33997343 29.6996577,0.181549438 25.8652238,0.12907923 Z M24.9442782,17.5748141 C23.3105199,19.1162773 21.557016,20.5250033 19.7003618,21.7876599 C17.8708542,20.4858422 16.1475677,19.0401744 14.5468134,17.4643398 C11.918794,14.8513462 8.79485246,10.9024419 8.83728135,6.92868098 C8.85896406,4.10252292 11.1587578,1.82733684 13.9780643,1.84290403 C15.7704283,1.85982834 17.4189681,2.82972813 18.3076474,4.39016545 L19.8569446,7.0584883 L21.4627218,4.42395218 C22.3845691,2.88307911 24.0533464,1.94885349 25.8455706,1.97031774 C28.6644237,2.01513425 30.9151663,4.33879669 30.8768834,7.1646357 C30.8345464,11.1379363 27.6272165,15.019175 24.9442782,17.5748141 Z" id="path-1"></path>
    </g>
  </SvgIcon48>
);

export default HeartIcon;
